import { cloneDeepJSON } from 'shared/libs/obj/cloneDeepJSON'
import { Filter } from 'shared/types/Common'
import { ParamKey } from 'shared/types/QueryModel'

export const cleanParams = (data: Filter): Filter => {
  const body = cloneDeepJSON(data)

  for (const key in body) {
    const value = body[key as ParamKey]
    if (value === '' || value === undefined || value === null) {
      delete body[key as ParamKey]
    }
  }

  return body
}
